import { render, staticRenderFns } from "./MenuAcoes.vue?vue&type=template&id=4efd9fe9&scoped=true"
import script from "./MenuAcoes.vue?vue&type=script&lang=js"
export * from "./MenuAcoes.vue?vue&type=script&lang=js"
import style0 from "./MenuAcoes.vue?vue&type=style&index=0&id=4efd9fe9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd9fe9",
  null
  
)

export default component.exports